<template>
  <div :class="$style.base">
    <SendToSupplier
      v-if="showSendModal"
      :supplierEmail="supplierEmail"
      @close="showSendModal = false"
      @submit="sent = true"
    />
    <Flex align="center">
      <BaseButton
        v-if="isOrdered && !sent"
        color="inverted"
        @click="showSendModal = true"
        v-test="'sendToSupplier'"
      >
        {{ $t('products.send_to_supplier') }}
      </BaseButton>
      <BaseText
        v-else-if="isOrdered && sent"
        inline
        iconAfter="check"
        v-test="'sentToSupplier'"
      >
        {{ $t('products.sent_to_supplier') }}
      </BaseText>
      <BaseButton
        v-if="isProcessable"
        :disabled="hasDeletedItems"
        :routerLink="{ name: 'stock-process' }"
        v-test="'processButton'"
      >
        {{ $t('global.actions.process') }}
      </BaseButton>
      <BaseButton
        v-if="isComplete"
        @click="onSetPaid"
        v-test="'paidButton'"
      >
        {{ $t('global.paid') }}
      </BaseButton>
    </Flex>
  </div>
</template>

<script lang="ts">
import gql from 'graphql-tag';
import { defineComponent } from 'vue';
import SendToSupplier from '../modals/SendToSupplier.vue';

export default defineComponent({
  components: {
    SendToSupplier,
  },
  props: {
    status: {
      type: String,
      required: true,
    },
    supplierEmail: {
      type: String,
      required: false,
    },
    stockOrderId: {
      required: true,
    },
    hasDeletedItems: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sent: false,
      showSendModal: false,
    };
  },
  computed: {
    isComplete() {
      return this.status === 'complete';
    },
    isOrdered() {
      return this.status === 'ordered';
    },
    isProcessable() {
      return this.status === 'ordered' || this.status === 'backorder';
    },
  },
  methods: {
    onSetPaid() {
      const id = this.stockOrderId;
      this.$apollo.mutate({
        mutation: gql`
          mutation updateStockOrder($input: UpdateStockOrderInput!) {
            updateStockOrder(input: $input) {
              stockOrder {
                id
                status
              }
            }
          }
        `,
        variables: {
          input: {
            id,
            status: 'paid',
          },
        },
        update(cache) {
          const cacheId = `StockOrder:${id}`;
          cache.evict({ id: cacheId, broadcast: false });
          cache.evict({ id: 'ROOT_QUERY', fieldName: 'stockOrders' });
          cache.gc();
        },
      });
    },
  },
});
</script>

<style
  lang="scss"
  module
>
.base {
  display: flex;
  align-items: flex-start;
  margin-bottom: $spacing;
}
</style>
